export default __webpack_public_path__ + "static/media/poster-6-ISB.e0d50b6b.png";